import { icons } from '../../../../shared/icons';
import MuiGrid from '../../UI/MuiGrid/MuiGrid';

const OpcijeMenijaGridProvider = ({ data, loading, handleOpenDelete }) => {
  const opcijeColumns = [
    {
      field: 'Naziv',
      headerName: 'Opcija programa',
      width: 400,
    },
    {
      field: 'Cvor',
      headerName: 'Čvor',
      width: 150,
      type: 'boolean',
    },
    {
      field: 'Podcvor',
      headerName: 'Podčvor',
      width: 150,
      type: 'boolean',
    },
    {
      field: 'opcije',
      headerName: '',
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => handleOpenDelete(e.id)}
        >
          {icons.DELETE_ICON}
        </span>
      ),
    },
  ];
  return (
    <div style={{ height: '600px', width: '80vw', marginTop: '10px' }}>
      <MuiGrid data={data} loading={loading} columns={opcijeColumns} />
    </div>
  );
};

export default OpcijeMenijaGridProvider;
